export const GET_ADMIN_PANEL_PRODUCT :string = "/DraftProducts";
export const PRODUCT_APPROVE :string = "/Approve";
export const PRODUCT_REJECT :string = "/Reject";
